import React, { useMemo } from "react";
import PortfolioHero from "app/layout/PortfolioHero";
import SeoHelmet from "app/layout/seoHelmet";

import Slider from "react-slick";
import { MDBBox } from "mdbreact";
import PortfolioModal from "../portfolio-gallery/portfolioModal";
import { ModalConsumer } from "core/components/modal/ModalContext";

import { usePortfolioGallery } from "app/state/hooks/usePortfolioGallery";
import Skeleton from "core/components/imageDownloader/page/listing/skeleton";
const NotableInstalls = () => {
  const { data, loading } = usePortfolioGallery();
  const details = data && data.getAllGalleryData;

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplaySpeed: 7000,
    speed: 2800,
    slidesToShow: 3,
    variableWidth: false,
    draggable: true,
    slidesToScroll: 3,
    lazyLoad: "ondemand",
    easing: "linear",
    pauseOnHover: false,

    responsive: [
      {
        breakpoint: 1045,
        settings: {
          autoplay: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          swipe: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: true,
          swipe: true,
        },
      },
    ],
  };

  const { firstNotable, notableInstalls } = useMemo(() => {
    const installs = details?.filter((detail) =>
      detail?.category?.includes("Notable Installs"),
    );
    const firstNotable = installs?.find((install) => install.position === "0");
    const notableInstalls = installs?.filter(
      (install) => install.position !== "0",
    );

    return { firstNotable, notableInstalls };
  }, [details]);

  const installsSlider = notableInstalls?.map((detail, index) => {
    return (
      <div key={index} className="card-wrapper">
        <div className="card-image-wrapper">
          <img className="card-image" src={detail.image} alt={detail.name} />
        </div>
        <div className="card-overlay">
          <div className="card-content">
            <div className="card-upper-part">
              <p className="card-location">{detail?.location}</p>
              <h3 className="card-name">{detail?.name}</h3>
              <p className="card-rep-group">{detail?.rep_group}</p>

              <p
                className="card-description"
                dangerouslySetInnerHTML={{
                  __html: detail.short_description,
                }}
              />
            </div>

            <div className="mt-auto">
              <ModalConsumer value={{ useWrapper: true }}>
                {({ showModal, hideModal }) => (
                  <MDBBox
                    onClick={(e) => {
                      showModal(() => {
                        return (
                          <PortfolioModal
                            hideModal={hideModal}
                            images={detail.hotspot}
                            portfolioName={detail.name}
                            portfolioDiscription={detail.short_description}
                          />
                        );
                      });
                    }}
                  >
                    <span className="explore-button">Explore</span>
                  </MDBBox>
                )}
              </ModalConsumer>
            </div>
          </div>
        </div>
      </div>
    );
  });
  const firstNotableSection = (
    <div className="notable-main">
      <div className="notable-container">
        <div className="notable-description">
          <h1 className="notable-title">{firstNotable?.name}</h1>
          <p className="notable-subtitle">{firstNotable?.location}</p>
          <p className="rep-group">{firstNotable?.rep_group}</p>
          <p
            className="notable-text"
            dangerouslySetInnerHTML={{
              __html: firstNotable?.description,
            }}
          />

          <ModalConsumer value={{ useWrapper: true }}>
            {({ showModal, hideModal }) => (
              <MDBBox
                onClick={(e) => {
                  showModal(() => {
                    return (
                      <PortfolioModal
                        hideModal={hideModal}
                        images={firstNotable.hotspot}
                        portfolioName={firstNotable.name}
                        portfolioDiscription={firstNotable.short_description}
                      />
                    );
                  });
                }}
              >
                <span className="explore-button mt-5">SHOP THIS LOOK</span>
              </MDBBox>
            )}
          </ModalConsumer>
        </div>

        <div className="image-wrapper">
          <img
            className="notable-main-image"
            src={firstNotable?.image}
            alt={firstNotable?.name || "Notable Image"}
          />
        </div>
      </div>

      <div className="notable-gallery">
        {firstNotable?.hotspot?.slice(0, 3)?.map((hotspot, index) => (
          <img
            key={index}
            src={hotspot.image}
            alt={hotspot.name}
            className="notable-images"
          />
        ))}
      </div>
    </div>
  );

  return (
    <>
      <SeoHelmet
        title="Notable Installs"
        url={"/notable-installs"}
        description={"Notable Installs"}
      />
      <PortfolioHero />
      {loading ? <Skeleton /> : firstNotableSection}
      {loading ? (
        <Skeleton />
      ) : (
        <div className="notable-slider">
          <h3 className="featured-subtitle">Featured Installs</h3>

          <Slider {...sliderSettings} className="featured-installs-slider">
            {installsSlider}
          </Slider>
        </div>
      )}
      {/* <div className="cs-wrapper">
        <h3 className="featured-subtitle case-studies-subtitle">
          Case Studies
        </h3>
        <CmsBlock id={"notable-install-case-studies"} />
      </div> */}
    </>
  );
};

export default NotableInstalls;
